import { createStore } from "vuex";

const store = createStore({
    state: {
        transpose: 0,
        // true enquanto o persist do transpose está em voo (single-flight).
        // Usado para desabilitar os botões de transpose até a resposta chegar.
        busy: false,
        // Espelho do pino de tom da música atual p/ o TriadTranspose:
        // { songId, pinned: number|null, canPin: boolean } | null
        transposePin: null,
        // Instrumento transpositor selecionado pelo músico (ex: 'concert_c', 'tenor_sax_bb', 'alto_sax_eb', 'french_horn_f')
        instrument: 'concert_c',
        // Traste do capotraste selecionado pelo músico (0 = sem capo)
        capo: 0
    }
})

export default store;